export default {
    fontSizes: {
        'xs': '12px',
        'sm': '14px',
        'md': '16px',
        'lg': '18px',
        'xl': '20px',
        'xxl': '24px',
        'xxxl': '32px',
        'xxxxl': '48px',
    },
    fontWeight: {
        'regular': 400,
        'semibold': 600,
        'bold': 700,
        'extrabold': 900,
    }
}
